























































import { mapGetters, mapActions } from 'vuex'
import defaulter from '@/modules/defaulter'
import phonenumber from '@/modules/phonenumber'
import MainNavbar from '@/components/MainNavbar.vue'
import GenericModal from '@/components/GenericModal.vue'

export default {
  name: 'AdminUsers',
  components: {
    MainNavbar,
    GenericModal,
  },
  data () {
    return {
      emptyUserForm: {
        id:           null,
        username:     '',
        authorized:   true,
        pw_reset:     false,
        role:         null,
        bank_id:      null,
        customer_id:  null,
        name:         '',
        phone_number: ''
      },
      userForm: {
        id:           null,
        username:     '',
        authorized:   true,
        pw_reset:     false,
        role:         null,
        bank_id:      null,
        customer_id:  null,
        name:         '',
        phone_number: ''
      },
      updateFields: ['name', 'phone_number', 'password'],
      showingPasswordInput: false,
      password1:    '',
      password2:    '',
    }
  },
  computed: {
    ...mapGetters([
      'sessionUser',
      'isPwResetRequired'
    ]),
  },
  methods: {
    ...mapActions([
      'updateProfile'
    ]),

    parsePhoneNumber (phone, event) {
      let parsed = phonenumber.parsePhoneNumber(phone)
      this.$set(this.userForm, 'phone_number', parsed.formatted)
      event.target.focus();
      event.target.setSelectionRange(parsed.formatted.length, parsed.formatted.length);
    },

    showPasswordInput () {
      this.showingPasswordInput = true
    },

    async submitForm () {
      let inputError = '', updates: any = {}
      // Name
      if (!this.userForm.name) {
        inputError = 'Name is required'
        this.$refs.nameInput.focus()
      }
      if (this.userForm.name !== this.sessionUser.name) {
        updates.name = this.userForm.name
      }
      // Phone Number
      if (!this.userForm.phone_number) {
        inputError = 'Phone Number is required'
        this.$refs.phoneNumberInput.focus()
      }
      if (this.userForm.phone_number !== this.sessionUser.phone_number) {
        updates.phone_number = this.userForm.phone_number
      }
      // Password
      if (this.password1) {
        if (this.password1 === this.password2) {
          updates.password = this.password1
        } else {
          inputError = 'Password and Retype do not match.'
          this.$refs.pwInput1.focus()
        }
      }
      if (inputError) {
        this.$bvToast.toast(inputError, {
          title: 'Input Error',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 5000
        })
        return
      }
      console.log('  updates:', updates)
      const result = await this.updateProfile(updates)
      console.log('  result:', result)
      if (!result.success) {
        this.$bvToast.toast(result.message, {
          title: 'Input Error',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 5000
        })
        return
      }
      this.$bvToast.toast(result.message, {
        title: 'Success',
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        autoHideDelay: 3000
      })
      this.showingPasswordInput = false
      this.password1 = ''
      this.password2 = ''
    },

  },
  mounted () {
    console.log('MyProfile.mounted', this.sessionUser)
    this.userForm = defaulter.merge(this.emptyUserForm, this.sessionUser)
    if (this.userForm.phone_number) {
      this.userForm.phone_number = phonenumber.parsePhoneNumber(this.userForm.phone_number).formatted
    }
    this.showingPasswordInput = false
    this.password1 = ''
    this.password2 = ''
  }
}
